module.exports = __webpack_public_path__ + "img/eye1.284bf768.svg";